const initialState = {
    products: [],
    productsfiltered: [],
    categories: [],
    product: null,
    loading: false,
    error: null,
    isOpen: false,
    filterSidebarOpen: false,
    showFiltered: false,
    cart: [],
    user: null,
    isAuthenticated: false
};



const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.payload
            }
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case 'GET_PRODUCTS':
            return {
                ...state,
                products: action.payload,
                productsfiltered: action.payload,
                error: null
            }
        case 'GET_CATEGORIES':
            return {
                ...state,
                categories: action.payload
            }
        case 'ADD_PRODUCT':
            return {
                ...state,
                products: [...state.products, action.payload],
                productsfiltered: [...state.productsfiltered, action.payload]
            }
        case 'UPDATE_PRODUCT':
            const updatedProducts = state.products.map(product =>
                product.id === action.payload.id ? action.payload : product
            );
            return {
                ...state,
                products: updatedProducts,
                productsfiltered: updatedProducts
            }
        case 'DELETE_PRODUCT':
            const filteredProducts = state.products.filter(product => product.id !== action.payload);
            return {
                ...state,
                products: filteredProducts,
                productsfiltered: filteredProducts
            }
        case 'SEARCH_PRODUCTS':
            return {
                ...state,
                productsfiltered: action.payload
            }
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                user: action.payload.user,
                isAuthenticated: true,
                error: null
            }
        case 'LOGIN_FAILURE':
        case 'REGISTER_FAILURE':
            return {
                ...state,
                error: action.payload,
                isAuthenticated: false
            }
        case 'LOGOUT':
            return {
                ...state,
                user: null,
                isAuthenticated: false
            }
        case 'PRODUCT_ID':
            return {
                ...state,
                product: action.payload
            }
        case 'SIDEBAR':
            return {
                ...state,
                isOpen: !state.isOpen
            }
        case 'TOGGLE_FILTER_SIDEBAR':
            return {
                ...state,
                filterSidebarOpen: !state.filterSidebarOpen
            }
        case 'ADD_TO_CART':
            const allProduct = state.products
            const addProduct = allProduct.find((e) => e.id === action.payload.id)
            const roductInCart = state.cart.find((i) => i.id === addProduct.id)
            return roductInCart ? {
                ...state,
                cart: state.cart.map((el) =>
                    el.id === addProduct.id
                        ? {
                            ...el, quantity: el.quantity + 1
                        } : el)
            }
                : {
                    ...state,
                    cart: [...state.cart, { ...addProduct, quantity: 1 }]
                }
        case 'DELETE_ONE_PRODUCT':
            const deleteOneProduct = state.cart.find((e) => e.id === action.payload.id)
            return deleteOneProduct.quantity > 1 ? {
                ...state,
                cart: state.cart.map((el) =>
                    el.id === action.payload.id
                        ? { ...el, quantity: el.quantity - 1 }
                        : el)
            } : {
                ...state,
                cart: state.cart.filter((el) => el.id !== action.payload.id)
            }
        case 'CLEAR_CART':
            return {
                ...state,
                cart: []
            }
        case 'INCREASE_QUANTITY':
            const productAmount = state.cart.find((i) => i.id === action.payload.id)
            return {
                ...state,
                cart: state.cart.map((el) =>
                    el.id === productAmount.id
                        ? {
                            ...el, quantity: el.quantity + 1
                        } : el)
            }
        case 'DECREASE_QUANTITY':
            const productDecrease = state.cart.find((i) => i.id === action.payload.id)
            return productDecrease.quantity < 2 ? {
                ...state,
                cart: state.cart.filter((el) => el.id !== action.payload.id)
            }
                : {
                    ...state,
                    cart: state.cart.map((el) =>
                        el.id === productDecrease.id
                            ? {
                                ...el, quantity: el.quantity - 1
                            } : el)
                }
        case 'CLEAR_PRODUCT':
            return {
                ...state,
                product: null
            }
        case 'FILTER_MENU':
            const all = state.products
            const filtered = action.payload === 'all' ? all : all.filter((d) => d.category?.name?.includes(action.payload))
            return {
                ...state,
                productsfiltered: filtered
            }
        case 'ORDER_BY':
            const all2 = state.productsfiltered.slice();
            const order = action.payload === "low" ? all2.sort(function (a, b) {
                        if (a.price > b.price) return 1;
                        if (a.price < b.price) return -1;
                        return 0;
                    })
                    : action.payload === "high"
                        ? all2.sort(function (a, b) {
                            if (a.price > b.price) return -1;
                            if (a.price < b.price) return 1;
                            return 0;
                        })
                        : all2;
            return {
                ...state,
                productsfiltered: order
            }

        default:
            return state;
    }
}

export default rootReducer;